import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip } from "@mui/material";

import * as S from "./styles";
import { addCard, StateProps } from "../../store";
import { Save } from "./styles";
import { BsClipboardCheck } from "react-icons/bs";
import favicon from "../../assets/favicon.png";
import { PiEyesFill } from "react-icons/pi";

const AddCardButton = ({ save }: { save: () => void }) => {
  const dispatch = useDispatch();
  const { cards } = useSelector((state: StateProps) => state);
  const focusedCardIndex = useSelector((state: StateProps) =>
    state.cards.findIndex((card) => card.isFocused),
  );

  const openPreviewTab = () => {
    const url = `/form/preview`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (cards.length < 2)
      dispatch(
        addCard({
          cardTitle: "제목없는 질문",
          focusedCardIndex: String(focusedCardIndex),
          cardId: String(Date.now()),
        }),
      );
  }, []);

  return (
    <S.Container>
      <Tooltip title="질문 추가" placement="right">
        <S.Fab
          color="primary"
          aria-label="add"
          onClick={() => {
            dispatch(
              addCard({ focusedCardIndex: String(focusedCardIndex), cardId: String(Date.now()) }),
            );
          }}
        >
          <AddIcon />
        </S.Fab>
      </Tooltip>
      <Tooltip title="저장" placement="right">
        <S.FabSave
          color="primary"
          aria-label="add"
          onClick={() => {
            save();
          }}
        >
          <BsClipboardCheck size={25} />
          <Save />
        </S.FabSave>
      </Tooltip>
      <S.FabButton
        style={{ justifyContent: "center" }}
        onClick={() => {
          openPreviewTab();
        }}
      >
        <PiEyesFill style={{ width: 28, height: "auto" }} />
      </S.FabButton>
      <S.ApplyButton
        onClick={() => {
          // window.open(
          //   `/form/apply/${initialCustomUrl !== "" ? initialCustomUrl : programId}`,
          //   "_blank",
          // );
        }}
      >
        <img src={favicon} alt="신청서바로가기" style={{ width: 26, height: "auto" }} />
      </S.ApplyButton>
    </S.Container>
  );
};

export default AddCardButton;
